import React, { FC, useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

import config from "./cookieConsentConfig";
import "./styles.css";
import cookieSVG from "./imgs/cookie.svg";

export const CookieConsentModal: FC = () => {
  useEffect(() => {
    CookieConsent.run({
      ...config,
      onModalHide: () => {
        window.location.reload();
      },
    });
  }, []);

  const onClickShowPreferences = () => {
    CookieConsent.showPreferences();
  };

  return (
    <>
      {CookieConsent.validConsent() && (
        <div
          id="cc-preferences-button"
          onClick={onClickShowPreferences}
          className="z-[100]"
        >
          <img
            id="cc-preferences-button-icon"
            src={cookieSVG}
            alt="Cookie Preferences"
          />
        </div>
      )}
    </>
  );
};
